import { render, staticRenderFns } from "./CreateSoftwareOfferModal.vue?vue&type=template&id=c704e498&scoped=true&"
import script from "./CreateSoftwareOfferModal.vue?vue&type=script&lang=js&"
export * from "./CreateSoftwareOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSoftwareOfferModal.vue?vue&type=style&index=0&id=c704e498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c704e498",
  null
  
)

export default component.exports